import axios from 'axios'

import { showToast } from 'vant';
import APIS from '@/api/api-config.js';
 
// 创建axios的对象
const instance = axios.create({
    baseURL: APIS.config.server,  //配置固定域名
    timeout: 5000
})
 
// 请求拦截
// 所有的网络请求都会走这个方法,可以在请求添加自定义内容
/* instance.interceptors.request.use(
    function (config) {
        config.headers.token = '123456' // 请求头添加token值
        
        return config
    },
    function (err) {
        return Promise.request(err)
    }
) */
 

/*  */
// 响应拦截
// 此处可以根据服务器返回的状态码做相应的数据
 instance.interceptors.response.use(
/*     function (response) {
			 debugger;
         const res = response
				 console.log(res);
         if (res.status === 500) {
             showToast('系統異常')
             return Promise.reject('error')
         } else if (res.errno === 502) {
             MessageBox.alert('系统内部错误，请联系管理员维护', '错误', {
                 confirmButtonText: '确定',
                 type: 'error'
             })
             return Promise.reject('error')
         }
     }, 
     function (err) {
			  console.log("error")
				console.log(err.response.data)
			 if(err.response.data.code == 500){
				 showToast('系統異常')
			 }
			 else if(err.response.data.message != undefined){
				 debugger;
				 showToast(err.response.data.message)
			 }
         return Promise.request(err)
     }*/
 )
// 封装get和post请求
export function get(url, params) {
    return instance.get(url, {params})
}
 
export function post(url, data) {
    return instance.post(url, data)
}
 
export default instance;